"use client";
import Tabs, { Tab } from "@/components/Tabs";
import Collapse from "@/components/ui/Collapse";
import {
	ProductDescriptionSetting,
	ProductJson,
	ProductTagJson,
} from "@/types/Product.type";
import Link from "next/link";
import ProductDescriptionsTags from "./ProductDescriptionsTags";
import useTranslationApi from "@/lib/hooks/useTranslationApi";
import { parserHtml } from "@/utils/utils";
type Props = {
	product: ProductJson;
	descriptions: ProductDescriptionSetting[];
	sku: string;
	className?: string;
};

const translate = {
	product_detail: "product_detail",
	product_sku: "product_sku",
	product_brand: "product_brand",
	product_origin: "product_origin",
	product_production_year: "product_production_year",
};

const ProductDescriptions = ({
	product,
	descriptions,
	sku,
	className,
}: Props) => {
	const { t } = useTranslationApi(Object.values(translate));

	const tabs: Tab[] = [
		{
		  title: t(translate.product_detail),
		  content: (
		    <>
		      <div className="mb-6">
		        <ul>
		          <li className=" flex items-center mb-[10px] ">
		            <p className="  min-w-[160px] font-bold   text-gray-400 text-base">
		              {t(translate.product_sku)}
		            </p>
		            <p className=" text-base text-gray-500">{sku}</p>
		          </li>

		          <li className=" list-disc flex items-center mb-[10px]">
		            <p className="  min-w-[160px] font-bold   text-gray-400 text-base">
		              {" "}
		              {t(translate.product_brand)}
		            </p>
		            <p className=" text-base text-gray-500">
		              {product.brand && (
		                <Link
		                  href={`/blogs/thuong-hieu-nuoc-hoa/${product.brand.handle}`}
		                  className=" text-blue-500"
		                >
		                  {" "}
		                  {product.brand.title}
		                </Link>
		              )}{" "}
		            </p>
		          </li>

		          <li className=" flex items-center mb-[10px]">
		            <p className="  min-w-[160px] font-bold   text-gray-400 text-base">
		              {" "}
		              {t(translate.product_origin)}
		            </p>
		            <p className=" text-gray-500 text-base">{product.origin}</p>
		          </li>

		          <li className=" flex items-center mb-[10px]">
		            <p className="  min-w-[160px] font-bold   text-gray-400 text-base">
		              {" "}
		              {t(translate.product_production_year)}
		            </p>
		            {product.production_year > 0 && (
		              <p className=" text-gray-500 text-base">
		                {product.production_year}
		              </p>
		            )}
		          </li>
		          <ProductDescriptionsTags tags={product.tags} />
		        </ul>
		      </div>
		      {product.description ? (
		        <div
		          dangerouslySetInnerHTML={{ __html: product.description }}
		        ></div>
		      ) : null}
		    </>
		  ),
		},
		...descriptions.map((dec) => ({
			title: dec.title,
			content: (
				<div
					dangerouslySetInnerHTML={{ __html: parserHtml(dec.content) }}></div>
			),
		})),
		// {
		// 	title: "Sử dụng và bảo quản",
		// 	content: (
		// 		<div>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}} >
		// 				Cách sử dụng được namperfume đề xuất dành cho bạn:
		// 			</p>
		// 			<div>
		// 				<ul style={{
		// 					listStyle: "disc",
		// 					paddingLeft: "18px",
		// 					fontSize : "14px",
		// 					color : "var(--gray-main)"
		// 				}}

		// 				>
		// 					<li >
		// 						Nước hoa mang lại mùi hương cho cơ thể bạn thông qua việc tiếp
		// 						xúc lên da và phản ứng với hơi ấm trên cơ thể của bạn. Việc được
		// 						tiếp xúc với các bộ phận như cổ tay, khuỷu tay, sau tai, gáy, cổ
		// 						trước là những vị trí được ưu tiên hàng đầu trong việc sử dụng
		// 						nước hoa bởi sự kín đáo và thuận lợi trong việc tỏa mùi hương.
		// 					</li>

		// 					<li >
		// 						Sau khi sử dụng, xịt nước hoa lên cơ thể, tránh dùng tay chà xát
		// 						hoặc làm khô da bằng những vật dụng khác, điều này phá vỡ các
		// 						tầng hương trong nước hoa, khiến nó có thể thay đổi mùi hương
		// 						hoặc bay mùi nhanh hơn.
		// 					</li>
		// 					<li >
		// 						Để chai nước hoa cách vị trí cần dùng nước hoa trong khoảng
		// 						15-20cm và xịt mạnh, dứt khoát để mật đổ phủ của nước hoa được
		// 						rộng nhất, tăng độ bám tỏa trên da của bạn.
		// 					</li>
		// 					<li >
		// 						Phần cổ tay được xịt nước hoa thường có nhiều tác động như lúc
		// 						rửa tay, đeo vòng, đồng hồ, do đó để đảm bảo mùi hương được duy
		// 						trì, bạn nên sử dụng nước hoa ở cổ tay ở tần suất nhiều hơn lúc
		// 						cần thiết.
		// 					</li>
		// 					<li >
		// 						Nước hoa có thể bám tốt hay không tốt tùy thuộc vào thời gian,
		// 						không gian, cơ địa, chế độ sinh hoạt, ăn uống của bạn, việc sử
		// 						dụng một loại nước hoa trong thời gian dài có thể khiến bạn bị
		// 						quen mùi, dẫn đến hiện tượng không nhận biết được mùi hương.
		// 						Mang theo nước hoa bên mình hoặc trang bị những mẫu mini tiện
		// 						dụng để giúp bản thân luôn tự tin mọi lúc mọi nơi.
		// 					</li>
		// 				</ul>
		// 				<p style={{
		// 					fontWeight: "bold",
		// 					marginBottom: "12px"
		// 				}}>Bảo quản nước hoa:</p>
		// 				<ul style={{
		// 					listStyle: "disc",
		// 					paddingLeft: "18px"
		// 				}} >
		// 					<li >
		// 						Nước hoa phổ thông (Designer) thường không có hạn sử dụng, ở một
		// 						số Quốc gia, việc ghi chú hạn sử dụng là điều bắt buộc để hàng
		// 						hóa được bán ra trên thị trường. Hạn sử dụng ở một số dòng nước
		// 						hoa được chú thích từ 24 đến 36 tháng, và tính từ ngày bạn mở
		// 						sản phẩm và sử dụng lần đầu tiên.
		// 					</li>

		// 					<li >
		// 						Nước hoa là tổng hợp của nhiều thành phần hương liệu tự nhiên và
		// 						tổng hợp, nên bảo quản nước hoa ở những nơi khô thoáng, mát mẻ,
		// 						tránh nắng, nóng hoặc quá lạnh, lưu ý không để nước hoa trong
		// 						cốp xe, những nơi có nhiệt độ nóng lạnh thất thường...
		// 					</li>
		// 				</ul>
		// 			</div>
		// 		</div>
		// 	),
		// },
		// {
		// 	title: "Vận chuyển và đổi trả",
		// 	content: (
		// 		<div style={{
		// 			fontSize : "14px",
		// 			color : "var(--gray-main)"
		// 		}}>
		// 			<p
		// 				style={{
		// 					fontWeight: "bold",
		// 					marginBottom: "12px",
		// 					fontSize:"15px"
		// 				}}
		// 			>Vận chuyển:</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}} >TP Hồ Chí Minh</p>

		// 			<p

		// 				style={{
		// 					marginBottom: "22px"
		// 				}}
		// 			>
		// 				Các đơn hàng tại Thành phố Hồ Chí Minh có thể chọn phương thức thanh
		// 				toán COD hoặc chuyển khoản, namperfume cam kết các quận trung tâm
		// 				quý khách sẽ nhận được hàng chậm nhất trong 3 giờ kể từ khi chốt đơn
		// 				đối với những đơn hàng trong ngày từ khung giờ 9.00 am đến 15.00 pm.
		// 				Nếu bạn muốn ship hẹn giờ, liên hệ với tổng đài CSKH 1900 0129 hoặc
		// 				fangape Facebook, Instagram của chúng tôi để được hỗ trợ.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}} >Các Tỉnh/Thành khác</p>
		// 			<p style={{
		// 				marginBottom: "22px"
		// 			}}>
		// 				namperfume thực hiện lên đơn hàng và thanh toán với hình thức COD
		// 				(Nhận hàng thanh toán) hoặc chuyển khoản trước khi Ship.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}} >Cách Thức Đóng Hàng</p>
		// 			<p		style={{
		// 					marginBottom: "22px"
		// 				}} >
		// 				Với các đơn hàng ship Tỉnh, các sản phẩm của bạn sẽ được đóng gói
		// 				cẩn thận và kỹ lưỡng, bao gồm nhiều lớp chống sốc, đóng hộp carton
		// 				và dán keo dính cẩn thận kèm hóa đơn, đảm bảo các sản phẩm được đến
		// 				tay khách hàng của chúng tôi một cách tốt nhất.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}}>Hỗ trợ từ namperfume</p>
		// 			<p 		style={{
		// 					marginBottom: "22px"
		// 				}}>
		// 				{" "}
		// 				Trong trường hợp các bạn mua tại Thành phố Hồ Chí Minh cần hỗ trợ
		// 				đóng hàng, hãy liên hệ hotline 1900 0129 hoặc fangape Facebook,
		// 				Instagram của chúng tôi để được hỗ trợ.
		// 			</p>
		// 			<hr style={{
		// 				marginTop : "20px",
		// 				marginBottom : "20px",
		// 			}} ></hr>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}}>Đổi trả hàng hóa:</p>
		// 			<p 		style={{
		// 					marginBottom: "22px"
		// 				}}>
		// 				Hàng hóa namperfume bán ra đảm bảo là hàng chính hãng 100%, chúng
		// 				tôi cam kết không bán hàng giả, hàng nhái, hàng không đảm bảo chất
		// 				lượng.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}}>Chính sách đổi hàng hóa:</p>
		// 			<p 		style={{
		// 					marginBottom: "22px"
		// 				}}>
		// 				Các trường hợp được đổi lại hàng hóa:
		// 				<br />
		// 				- Với những sản phẩm lỗi kết cấu sản phẩm do quá trình sản xuất của
		// 				hãng, hay lỗi do vận chuyển dẫn đến việc sản phẩm bị méo mó, thay
		// 				đổi hình dạng, hư hỏng bộ phận vòi xịt, ống xịt, bị nứt, vỡ.
		// 				<br />- Đối với những sản phẩm đổi vì lý do cá nhân (tặng, được
		// 				tặng), sản phẩm đổi chỉ được áp dụng trong thời gian 10 ngày kể từ
		// 				khi sản phẩm được bán ra. Sản phẩm đổi phải đảm bảo chưa được sửa
		// 				dụng, đối với hàng Full seal thì phải còn nguyên seal, đối với các
		// 				sản phẩm Giftset, Tester phải đảm bảo còn nguyên hộp, sản phẩm chưa
		// 				bị can thiệp và sử dụng. sản phẩm sẽ được chúng tôi kiểm tra lại để
		// 				đảm bảo sản phẩm là hàng hóa của bên chúng tôi phân phối.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}}>
		// 				Các trường hợp không được áp dụng đổi lại hàng hóa:
		// 			</p>
		// 			<p 		style={{
		// 					marginBottom: "22px"
		// 				}}>
		// 				- Sản phẩm không phải do namperfume cung cấp, không chứng minh được
		// 				nguồn gốc của sản phẩm (hóa đơn, thời gian mua hàng)
		// 				<br />
		// 				- Sản phẩm được mua quá 10 ngày kể từ khi sản phẩm được bán ra.
		// 				<br />- Sản phẩm đã được sử dụng hoặc bị tác động từ người mua dẫn
		// 				đến hư hại.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}}>Quy trình đổi hàng hóa:</p>
		// 			<p 		style={{
		// 					marginBottom: "22px"
		// 				}}>
		// 				- Sau khi bạn đáp ứng được các điều kiện về đổi lại hàng hóa của
		// 				chúng tôi, hãy liên hệ với chúng tôi để được hỗ trợ.
		// 				<br />- Sau khi tiếp nhận thông tin và check kiểm các điều kiện, nếu
		// 				bạn đáp ứng đủ điều kiện, chúng tôi sẽ hỗ trợ ngay và nhanh nhất cho
		// 				bạn.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}}>Chính sách trả hàng hóa:</p>
		// 			<p >
		// 				Các trường hợp được trả lại hàng hóa: - Với những sản phẩm lỗi kết
		// 				cấu sản phẩm do quá trình sản xuất của hãng, hay lỗi do vận chuyển
		// 				dẫn đến việc sản phẩm bị méo mó, thay đổi hình dạng, hư hỏng bộ phận
		// 				vòi xịt, ống xịt, bị nứt, vỡ.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}}>
		// 				Các trường hợp không được chấp nhận trả lại hàng hóa:
		// 			</p>
		// 			<p 		style={{
		// 					marginBottom: "22px"
		// 				}}>
		// 				- Sản phẩm bị tác động từ phía người sử dụng dẫn đến hư hỏng, móp
		// 				méo, thay đổi hình dạng.
		// 				<br />
		// 				- Sản phẩm đã được sử dụng
		// 				<br />- Chúng tôi không chấp nhận trả lại hàng, hoàn lại tiền với
		// 				các trường hợp muốn trả lại hàng vì lý do cá nhân như không thích
		// 				nữa, thay đổi ý định, hay các lý do cá nhân khác.
		// 			</p>
		// 			<p style={{
		// 				fontWeight: "bold",
		// 				marginBottom: "12px"
		// 			}}>
		// 				Quy trình trả hàng, hoàn tiền:
		// 			</p>
		// 			<p >
		// 				- Sau khi bạn đáp ứng được các điều kiện về trả lại hàng hóa của
		// 				chúng tôi, hãy liên hệ với chúng tôi để được hỗ trợ
		// 				<br />- Sau khi tiếp nhận thông tin và check kiểm các điều kiện, nếu
		// 				bạn đáp ứng đủ điều kiện, chúng tôi sẽ hỗ trợ ngay và nhanh nhất cho
		// 				bạn.
		// 			</p>
		// 		</div>
		// 	),
		// },
	];
	return (
		<div className={className}>
			<Tabs tabs={tabs} classNameBody="md:w-[66%] w-full md:block hidden" />
			<div className="block md:hidden">
				<Collapse
					items={tabs.map((tab, index) => {
						return {
							header: tab.title,
							body: tab.content,
							key: index,
						};
					})}
				/>
			</div>
		</div>
	);
};

export default ProductDescriptions;
